import React from 'react'
import IsViewport from './IsViewport'
import PropTypes from 'prop-types'
import objectAssign from 'object-assign'

const types = IsViewport.mappings.map(([propName]) => propName)

/**
 * Create a React functional component based on the type.
 *
 * @param {string} currentType
 */
function typeHelper (currentType) {
  /**
   * @param {JSX.IntrinsicAttributes} props
   */
  function TypeHelper (props) {
    const newProps = objectAssign(
      {},
      props,
      types.reduce(
        (typeMap, type) =>
          objectAssign({}, typeMap, {
            [type]: props.invert ? type !== currentType : type === currentType
          }),
        {}
      )
    )

    return <IsViewport {...newProps} />
  }
  TypeHelper.displayName =
    currentType.slice(0, 1).toUpperCase() + currentType.slice(1)
  TypeHelper.propTypes = {
    invert: PropTypes.bool
  }

  return TypeHelper
}

export default typeHelper
